// sidebarStore.ts
import { create } from 'zustand';
import { SidebarStateTypes } from '../sidebar/sidebar-types';

export const useSidebarStore = create<{
  sidebarState: SidebarStateTypes;
  setSidebarState: (state: Partial<SidebarStateTypes>) => void;
}>((set) => ({
  sidebarState: {
    modalityManagement: false,
    clusterManagement: false,
    resourceFileLibrary: false,
    surveyResult: false,
    showSideBar: true,
  },
  setSidebarState: (state) =>
    set((prev) => ({
      sidebarState: { ...prev.sidebarState, ...state },
    })),
}));